export const consecutiveSpaces = /\ +/g;
